import React from 'react'
import { Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import GapDataserieBoxContent from './GapDataserieBoxContent';
import { ActionButton, Dropdown } from '@fluentui/react';
import { useState } from 'react';
import { useContext } from 'react';
import MainAppContext from '../../../../../../MainAppContext';
import { __BoardCalendarFilter } from '../../../../../../common/Dictionaries';
import CalendarFilterPanel from '../../../Board/CalendarFilter/CalendarFilterPanel';

function GapDataserieFullBox(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
   
    const {
        inputParam_GapId = null,
        inputParam_GapAnalyzeId = null,
        inputParam_ElementId = null,
        inputParam_GapRevision = null,
        inputParam_DataserieFullData = null,
        inputParam_GapRevisionDataserieList = null,
        inputParam_GapElementList = null,
        gapAnalyzeDataseriesIds = null,
        inputParam_SelectecDataserieId = null,
        inputParam_SetSelectecDataserieId = null,
        inputParam_SetterStructurerevisionDataserieFullList = null,
        inputParam_SetFireGetLastActions = null,
    } = props;

    const [isCalendarFilterPanelOpen, setIsCalendarFilterPanelOpen] = useState(false);

    const onChangeDataserieIdSelection = (ev, item) => {
        inputParam_SetSelectecDataserieId(item.key);
        inputParam_SetSelectecDataserieId && inputParam_SetSelectecDataserieId(item.key)
        inputParam_SetterStructurerevisionDataserieFullList && inputParam_SetterStructurerevisionDataserieFullList()
    }

    const onOpenCalendarFilterPanel = (e) => {
        setIsCalendarFilterPanelOpen(true)
    };

    setTimeout(() => {
        inputParam_SelectecDataserieId !== 0 && window.scrollTo(0, document.body.scrollHeight)
    }, 500);
    return (
        <>
            <Card className="h-1001">
                <Card.Header className="card-header-compact">
                    <Card.Title className="d-flex justify-content-between">
                        <b>{t('data-lang-boxname-revisiondataserie')}</b>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                <div className='book-toolbar d-flex float-end ps-3 py-1'>
                    {
                        gapAnalyzeDataseriesIds !== null &&
                        <>
                            <b className='pe-2 pt-1'>{t('data-lang-lbl-dataserie')}: </b>
                            <Dropdown
                                placeholder={" "}
                                styles={ {title: { width: "400px", height: "27px"}} }
                                className="pt-1"
                                options={gapAnalyzeDataseriesIds.map((item, index) => {return {  key: item.id, text: item.name.indexOf('data-lang-lbl-') !== -1 ? t(item.name) : item.name, title: item.name.indexOf('data-lang-lbl-') !== -1 ? t(item.name) : item.name, }})}
                                selectedKey={inputParam_SelectecDataserieId}
                                onChange={(event, option) => onChangeDataserieIdSelection(event, option)}
                            />
                        </>
                    }
                    <ActionButton iconProps={{ iconName: "CalendarSettings"}} onClick={() => onOpenCalendarFilterPanel()} allowDisabledFocus >
                        { t(__BoardCalendarFilter.find(x => x.key === contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId).text)}
                    </ActionButton>
                </div>
                </Card.Footer>
                <Card.Body className="card-gaprevisions p-2 h-1001">
                    {
                        (inputParam_GapRevisionDataserieList !== null && inputParam_DataserieFullData.gapFishboneList !== null && (inputParam_DataserieFullData.revisionDataserieFullList !== null && inputParam_DataserieFullData.revisionDataserieFullList !== undefined) && inputParam_GapElementList !== null) ?
                        <>
                            {
                                inputParam_DataserieFullData.revisionDataserieFullList.length > 0 &&
                                <>
                                    <GapDataserieBoxContent
                                        inputParam_GapId={inputParam_GapId}
                                        inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                                        inputParam_ElementId={inputParam_ElementId}
                                        inputParam_GapRevision={inputParam_GapRevision}
                                        inputParam_DataserieFullData={inputParam_DataserieFullData}
                                        inputParam_GapRevisionDataserieList={inputParam_GapRevisionDataserieList}
                                        inputParam_GapElementList={inputParam_GapElementList}
                                        inputParam_SelectecDataserieId={inputParam_SelectecDataserieId}
                                        inputParam_SetFireGetLastActions={inputParam_SetFireGetLastActions}
                                    /> 
                                    <NoDataLayer display={inputParam_DataserieFullData.revisionDataserieFullList.length === 0 && inputParam_DataserieFullData.gapFishboneList.length === 0 && inputParam_GapRevisionDataserieList.length === 0} />
                                </>
                            }
                        </>
                         : <NoDataLayer display={true} />
                    }
                </Card.Body>
            </Card>
            <CalendarFilterPanel
                inputParam_IsPanelOpen={isCalendarFilterPanelOpen}
                inputParam_SetterIsPanelOpen={setIsCalendarFilterPanelOpen}
                inputParam_SetDataserieFullListToNull={inputParam_SetterStructurerevisionDataserieFullList}
            />
        </>
    );
}

GapDataserieFullBox.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapRevision: PropTypes.object,
    inputParam_DataserieFullData: PropTypes.object,
    inputParam_GapRevisionDataserieList: PropTypes.array,
    inputParam_GapElementList: PropTypes.array,
    setterDataToNull: PropTypes.func.isRequired,
    inputParam_SetterStructurerevisionDataserieFullList: PropTypes.func, 
    gapAnalyzeDataseriesIds: PropTypes.array, 
       
};

export default GapDataserieFullBox;

